// Adaptador entre la salida cruda de core/acoustics.js (que da
// { bands: [{ freq, trBefore: { sabine, eyring, millington, mean }, trAfter: {...} }] })
// y los formatos que esperan los consumidores:
//
// - PDF generator y la gráfica: bands con trBefore/trAfter NUMÉRICOS planos.
// - AuralizationEngine.setTR60(beforeBands, afterBands): { 125: number, 250: number, ... }.
//
// Mantiene una sola fuente de verdad para no duplicar la lógica de aplanado.

function flatBand(b) {
  const before = typeof b.trBefore === 'object' ? (b.trBefore.mean ?? 0) : Number(b.trBefore || 0);
  const after = typeof b.trAfter === 'object' ? (b.trAfter.mean ?? 0) : Number(b.trAfter || 0);
  return { freq: b.freq, trBefore: before, trAfter: after };
}

export function flattenResults(raw) {
  if (!raw || !Array.isArray(raw.bands)) return null;
  const bands = raw.bands.map(flatBand);
  const mids = bands.filter((b) => b.freq === 500 || b.freq === 1000);
  const meanOf = (key) => (mids.length ? mids.reduce((s, x) => s + x[key], 0) / mids.length : 0);
  const trBeforeMean = meanOf('trBefore');
  const trAfterMean = meanOf('trAfter');
  return {
    bands,
    trBeforeMean,
    trAfterMean,
    trBeforeAt500: bands.find((b) => b.freq === 500)?.trBefore ?? 0,
    trAfterAt500: bands.find((b) => b.freq === 500)?.trAfter ?? 0,
    trBeforeAt1000: bands.find((b) => b.freq === 1000)?.trBefore ?? 0,
    trAfterAt1000: bands.find((b) => b.freq === 1000)?.trAfter ?? 0,
  };
}

export function bandsForAuralization(raw) {
  if (!raw || !Array.isArray(raw.bands)) return { before: {}, after: {} };
  const before = {};
  const after = {};
  for (const b of raw.bands) {
    const fb = flatBand(b);
    before[fb.freq] = fb.trBefore;
    after[fb.freq] = fb.trAfter;
  }
  return { before, after };
}
